"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/components/Modal/index.ts
var Modal_exports = {};
__export(Modal_exports, {
  ActionsPanel: () => ActionsPanel,
  BaseModal: () => BaseModal,
  CloseButton: () => CloseButton,
  Modal: () => Modal,
  ModalContainer: () => ModalContainer,
  fadeTransitionDuration: () => fadeTransitionDuration
});
module.exports = __toCommonJS(Modal_exports);

// src/components/Modal/Modal.tsx
var import_react7 = __toESM(require("react"));

// src/components/Modal/BaseModal.tsx
var import_react = __toESM(require("react"));
var import_react_modal = __toESM(require("react-modal"));
var import_classnames = __toESM(require("classnames"));
var fadeTransitionDuration = 150;
var BaseModal = (_a) => {
  var _b = _a, {
    open,
    ariaHideApp = false,
    overlayRef,
    contentRef,
    className,
    overlayClassName,
    children,
    hideOverlay = false,
    yPosition = "middle"
  } = _b, props = __objRest(_b, [
    "open",
    "ariaHideApp",
    "overlayRef",
    "contentRef",
    "className",
    "overlayClassName",
    "children",
    "hideOverlay",
    "yPosition"
  ]);
  const [modalOpen, setModalOpen] = (0, import_react.useState)(open);
  (0, import_react.useEffect)(() => {
    setTimeout(() => setModalOpen(open), open ? 0 : fadeTransitionDuration);
  }, [open]);
  const modalProps = (0, import_react.useMemo)(() => {
    const modalProps2 = __spreadProps(__spreadValues({}, props), {
      ariaHideApp,
      isOpen: modalOpen,
      overlayClassName: (0, import_classnames.default)(
        "modal-overlay",
        overlayClassName,
        [
          " v2-flex v2-z-[9999] v2-text-base",
          "v2-transition v2-transition-opacity"
        ],
        {
          "v2-fixed v2-bg-black/50 v2-overflow-y-scroll v2-inset-0": !hideOverlay,
          "v2-absolute v2-inset-x-0 v2-justify-self-center v2-self-center v2-w-fit v2-h-fit": hideOverlay,
          "v2-top-0": hideOverlay && yPosition === "top",
          "v2-inset-y-0": hideOverlay && yPosition === "middle",
          "v2-bottom-0": hideOverlay && yPosition === "bottom",
          "v2-animate-fade-in-150": open,
          "v2-animate-fade-out-150": !open
        }
      ),
      className: (0, import_classnames.default)(
        "modal-contents",
        className,
        [
          "v2-relative v2-bg-white v2-shadow-md v2-rounded !v2-px-7 v2-pb-7",
          "v2-outline-none v2-p-5 v2-border-none v2-inset-0 ",
          "md:v2-inset-px v2-w-auto md:v2-w-full"
        ],
        {
          "!v2-m-auto": hideOverlay,
          "!v2-mx-auto ": !hideOverlay,
          "v2-mb-auto": !hideOverlay && yPosition === "top",
          "v2-my-auto": !hideOverlay && yPosition === "middle",
          "v2-mt-auto": !hideOverlay && yPosition === "bottom"
        }
      )
    });
    if (overlayRef) {
      modalProps2.overlayRef = (node) => overlayRef.current = node;
    }
    if (contentRef) {
      modalProps2.contentRef = (node) => contentRef.current = node;
    }
    return modalProps2;
  }, [modalOpen, overlayRef, contentRef, props, yPosition, hideOverlay]);
  return /* @__PURE__ */ import_react.default.createElement(import_react_modal.default, __spreadValues({}, modalProps), children);
};

// src/components/Modal/ModalContainer.tsx
var import_react2 = __toESM(require("react"));
var import_classnames2 = __toESM(require("classnames"));
var ModalContainer = ({
  children,
  className
}) => {
  return /* @__PURE__ */ import_react2.default.createElement(
    "div",
    {
      className: (0, import_classnames2.default)("modal-container", className, [
        "v2-w-full v2-flex v2-flex-col"
      ])
    },
    children
  );
};

// src/components/Modal/CloseButton.tsx
var import_react3 = __toESM(require("react"));
var import_classnames3 = __toESM(require("classnames"));
var import_react_fontawesome = require("@fortawesome/react-fontawesome");

// node_modules/@fortawesome/pro-solid-svg-icons/index.mjs
var faXmark = {
  prefix: "fas",
  iconName: "xmark",
  icon: [320, 512, [128473, 10005, 10006, 10060, 215, "close", "multiply", "remove", "times"], "f00d", "M310.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 210.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L114.7 256 9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 301.3 265.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L205.3 256 310.6 150.6z"]
};
var faTimes = faXmark;

// src/components/Modal/CloseButton.tsx
var CloseButton = ({ className, onClick }) => {
  return /* @__PURE__ */ import_react3.default.createElement(
    import_react_fontawesome.FontAwesomeIcon,
    {
      icon: faTimes,
      className: (0, import_classnames3.default)("modal-close-btn", className, [
        "v2-text-neutral-300 hover:v2-text-orange-700 v2-cursor-pointer",
        "v2-flex v2-top-6 v2-right-6 v2-w-fit v2-ml-auto v2-text-[25px]",
        "v2-absolute v2-w-6 v2-h-6"
      ]),
      onClick
    }
  );
};

// src/components/Modal/ActionsPanel.tsx
var import_react5 = __toESM(require("react"));
var import_classnames5 = __toESM(require("classnames"));

// src/components/Button/index.tsx
var import_react4 = __toESM(require("react"));
var import_classnames4 = __toESM(require("classnames"));
var sizeClasses = {
  DEFAULT: "v2-font-bold v2-border v2-font-circular",
  ["sm" /* Small */]: "v2-py-[5px] v2-px-2.5 v2-text-xs",
  ["md" /* Medium */]: "v2-py-2.5 v2-px-[15px] v2-text-[15px]",
  ["lg" /* Large */]: "v2-py-2.5 v2-px-[15px] v2-text-base",
  ["xl" /* ExtraLarge */]: "v2-py-2.5 v2-px-[15px] v2-text-lg"
};
var shapeClasses = {
  ["rectangle" /* Rectangle */]: "",
  ["round" /* Round */]: "v2-rounded-md"
};
var variantClasses = {
  ["danger" /* Danger */]: "v2-border-solid v2-border-pink-900 v2-text-white",
  ["danger-white" /* DangerWhite */]: "v2-border-solid v2-border-neutral-500 v2-text-neutral-900",
  ["default" /* Default */]: "v2-border-solid v2-border-turquoise v2-text-white",
  ["disabled" /* Disabled */]: "v2-border-solid v2-border-neutral-200 v2-text-neutral-400",
  ["primary" /* Primary */]: "v2-border-solid v2-text-neutral-900 v2-border-yellow-500",
  ["secondary" /* Secondary */]: "v2-border-solid v2-border-neutral-500",
  ["secondary-white" /* SecondaryWhite */]: "v2-text-white v2-border-solid v2-border-white",
  ["info" /* Info */]: "v2-text-brown-700 v2-border-solid v2-border-neutral-200",
  ["blue" /* Blue */]: "v2-text-white v2-border-solid v2-border-blue-500",
  ["magenta" /* Magenta */]: "v2-text-white v2-border-solid v2-border-magenta-500",
  ["icon" /* Icon */]: "v2-text-neutral-400 v2-border-none v2-outline-none",
  ["rounded" /* Rounded */]: "v2-cursor-pointer v2-rounded-full v2-border-1 v2-border-solid v2-border-neutral-500"
};
function Button(_a) {
  var _b = _a, {
    children,
    variant: variantProp,
    size: sizeProp,
    shape = "rectangle" /* Rectangle */,
    bgColorClassName,
    disableHover
  } = _b, props = __objRest(_b, [
    "children",
    "variant",
    "size",
    "shape",
    "bgColorClassName",
    "disableHover"
  ]);
  var _a2;
  const variant = (0, import_react4.useMemo)(() => {
    if (props.disabled) {
      return "disabled" /* Disabled */;
    }
    if (variantProp != null) {
      return variantProp;
    }
    if (props.primary) {
      return "primary" /* Primary */;
    }
    if (props.secondary) {
      return "secondary" /* Secondary */;
    }
    if (props.info) {
      return "info" /* Info */;
    }
    if (props.danger) {
      return "danger" /* Danger */;
    }
    return "default" /* Default */;
  }, [props]);
  const size = (0, import_react4.useMemo)(() => {
    if (sizeProp != null) {
      return sizeProp;
    }
    if (props.sm || props.small) {
      return "sm" /* Small */;
    }
    if (props.md || props.medium) {
      return "md" /* Medium */;
    }
    if (props.lg || props.large) {
      return "lg" /* Large */;
    }
    if (props.xl || props.extraLarge) {
      return "xl" /* ExtraLarge */;
    }
    return "md" /* Medium */;
  }, [props]);
  const disabledClass = (0, import_react4.useMemo)(() => {
    if (props.disabled) {
      switch (variant) {
        case "primary" /* Primary */:
          return "!v2-text-neutral-300 !v2-bg-neutral-100 !v2-border-neutral-100";
        case "secondary" /* Secondary */:
        case "secondary-white" /* SecondaryWhite */:
          return "!v2-text-neutral-300 !v2-bg-transparent !v2-border-white";
      }
    }
    return "";
  }, [props, variant]);
  const hoverClass = (0, import_react4.useMemo)(() => {
    if (!disableHover) {
      switch (variant) {
        case "danger" /* Danger */:
          return "hover:v2-bg-orange-700 hover:v2-border-orange-700";
        case "danger-white" /* DangerWhite */:
          return "hover:v2-bg-orange-600 hover:v2-border-orange-600 hover:v2-text-white";
        case "default" /* Default */:
          return "hover:v2-bg-turquoise-900 hover:v2-border-turquoise-900";
        case "disabled" /* Disabled */:
          return "hover:v2-bg-neutral-300 hover:v2-border-neutral-300 v2-cursor-not-allowed";
        case "primary" /* Primary */:
          return "hover:v2-bg-yellow-300 hover:v2-border-yellow-300";
        case "secondary" /* Secondary */:
          return "hover:v2-bg-yellow-500 hover:v2-border-transparent";
        case "secondary-white" /* SecondaryWhite */:
          return "hover:v2-bg-yellow-500 hover:v2-border-transparent hover:v2-text-neutral-900";
        case "blue" /* Blue */:
          return "hover:v2-bg-blue-700 hover:v2-border-blue-700";
        case "magenta" /* Magenta */:
          return "hover:v2-bg-magenta-700 hover:v2-border-magenta-700";
        case "info" /* Info */:
          return "hover:v2-bg-neutral-300 hover:v2-border-neutral-300";
        case "icon" /* Icon */:
          return "hover:v2-text-turquoise";
        case "rounded" /* Rounded */:
          return "hover:v2-bg-yellow-500 hover:v2-border-yellow-500";
      }
    }
    return "";
  }, [props, variant]);
  const bgColorClass = (0, import_react4.useMemo)(() => {
    if (!bgColorClassName) {
      switch (variant) {
        case "danger" /* Danger */:
          return "v2-bg-orange-600";
        case "danger-white" /* DangerWhite */:
          return "v2-bg-white";
        case "default" /* Default */:
          return "v2-bg-turquoise";
        case "disabled" /* Disabled */:
          return "v2-bg-neutral-200 ";
        case "primary" /* Primary */:
          return "v2-bg-yellow-500";
        case "secondary" /* Secondary */:
        case "secondary-white" /* SecondaryWhite */:
          return "v2-bg-transparent ";
        case "blue" /* Blue */:
          return "v2-bg-blue-500";
        case "magenta" /* Magenta */:
          return "v2-bg-magenta-500";
        case "info" /* Info */:
          return "v2-bg-neutral-200";
        case "icon" /* Icon */:
          return "v2-bg-transparent";
        case "rounded" /* Rounded */:
          return "v2-bg-transparent ";
      }
    }
    return bgColorClassName;
  }, [props, variant]);
  const className = (0, import_react4.useMemo)(() => {
    return [
      sizeClasses.DEFAULT,
      sizeClasses[size],
      shapeClasses[shape],
      variantClasses[variant],
      disabledClass,
      hoverClass,
      bgColorClass
    ].join(" ");
  }, [size, variant, shape]);
  return /* @__PURE__ */ import_react4.default.createElement("button", __spreadProps(__spreadValues({}, props), { className: (0, import_classnames4.default)(`${(_a2 = props.className) != null ? _a2 : ""} ${className}`) }), children);
}

// node_modules/@fortawesome/free-solid-svg-icons/index.mjs
var faSpinner = {
  prefix: "fas",
  iconName: "spinner",
  icon: [512, 512, [], "f110", "M304 48c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48zm0 416c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48zM48 304c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48zm464-48c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48zM142.9 437c18.7-18.7 18.7-49.1 0-67.9s-49.1-18.7-67.9 0s-18.7 49.1 0 67.9s49.1 18.7 67.9 0zm0-294.2c18.7-18.7 18.7-49.1 0-67.9S93.7 56.2 75 75s-18.7 49.1 0 67.9s49.1 18.7 67.9 0zM369.1 437c18.7 18.7 49.1 18.7 67.9 0s18.7-49.1 0-67.9s-49.1-18.7-67.9 0s-18.7 49.1 0 67.9z"]
};

// src/components/Modal/ActionsPanel.tsx
var import_react_fontawesome2 = require("@fortawesome/react-fontawesome");
var ActionsPanel = ({
  className,
  confirmButtonProps,
  cancelButtonProps
}) => {
  var _a, _b, _c, _d;
  return /* @__PURE__ */ import_react5.default.createElement(
    "div",
    {
      className: (0, import_classnames5.default)(
        "modal-actions-panel",
        className,
        "v2-shrink v2-flex v2-gap-x-5 v2-flex v2-flex-col xxs:v2-flex-row"
      )
    },
    (confirmButtonProps == null ? void 0 : confirmButtonProps.onClick) && /* @__PURE__ */ import_react5.default.createElement(
      Button,
      __spreadProps(__spreadValues({}, confirmButtonProps), {
        variant: (_a = confirmButtonProps == null ? void 0 : confirmButtonProps.variant) != null ? _a : "primary" /* Primary */
      }),
      (confirmButtonProps == null ? void 0 : confirmButtonProps.loading) ? /* @__PURE__ */ import_react5.default.createElement(
        import_react_fontawesome2.FontAwesomeIcon,
        {
          icon: faSpinner,
          className: "v2-animate-spin v2-mr-2"
        }
      ) : /* @__PURE__ */ import_react5.default.createElement(import_react5.default.Fragment, null),
      (_b = confirmButtonProps == null ? void 0 : confirmButtonProps.text) != null ? _b : "Confirm"
    ),
    (cancelButtonProps == null ? void 0 : cancelButtonProps.onClick) && /* @__PURE__ */ import_react5.default.createElement(
      Button,
      __spreadProps(__spreadValues({}, cancelButtonProps), {
        variant: (_c = cancelButtonProps == null ? void 0 : cancelButtonProps.variant) != null ? _c : "info" /* Info */
      }),
      (_d = cancelButtonProps == null ? void 0 : cancelButtonProps.text) != null ? _d : "Cancel"
    )
  );
};

// src/components/Modal/Icon.tsx
var import_react6 = __toESM(require("react"));
var import_classnames6 = __toESM(require("classnames"));
var Icon = ({ imageUrl, className }) => {
  return /* @__PURE__ */ import_react6.default.createElement(
    "img",
    {
      className: (0, import_classnames6.default)(className, "v2-h-10 v2-w-10 v2-mx-auto v2-my-2"),
      src: imageUrl
    }
  );
};

// src/components/Modal/Modal.tsx
function Modal({
  open = false,
  hideCloseButton = false,
  hideActions = false,
  iconUrl,
  className,
  overlayClassName,
  panelClassName,
  actionsPanelClassName,
  closeButtonClassName,
  iconClassName,
  children,
  confirmButtonProps,
  cancelButtonProps,
  onModalClose,
  onAfterOpen,
  noCloseOnOverlayClick = false,
  noCloseOnEsc = false,
  overlayRef,
  contentRef,
  hideOverlay = false,
  yPosition
}) {
  const closeButtonProps = {
    onClick: onModalClose,
    className: closeButtonClassName
  };
  const actionsPanelProps = {
    className: actionsPanelClassName,
    confirmButtonProps,
    cancelButtonProps
  };
  const iconProps = {
    className: iconClassName,
    imageUrl: iconUrl
  };
  const baseModalProps = {
    open,
    className,
    overlayClassName,
    shouldCloseOnOverlayClick: !noCloseOnOverlayClick && !hideOverlay,
    shouldCloseOnEsc: !noCloseOnEsc,
    onRequestClose: onModalClose,
    onAfterOpen,
    overlayRef,
    contentRef,
    hideOverlay,
    yPosition
  };
  return /* @__PURE__ */ import_react7.default.createElement(BaseModal, __spreadValues({}, baseModalProps), /* @__PURE__ */ import_react7.default.createElement(ModalContainer, { className: panelClassName }, !hideCloseButton && /* @__PURE__ */ import_react7.default.createElement(CloseButton, __spreadValues({}, closeButtonProps)), iconUrl && /* @__PURE__ */ import_react7.default.createElement(Icon, __spreadValues({}, iconProps)), children, !hideActions && /* @__PURE__ */ import_react7.default.createElement(ActionsPanel, __spreadValues({}, actionsPanelProps))));
}
